var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import ReactDOM from "react-dom";
/**
 * Mounts a temporary modal component in the document body and waits for it to be closed.
 * Returns a promise that resolves when the modal is submitted or closed.
 *
 * @param renderModal The modal render function. Receives a `resolve` and `reject` function arguments for signalling that the modal is closed.
 *
 * Example:
 *
 * ```tsx
 * const confirmed = await showModal<boolean>(resolve =>
 *   <ConfirmModal onConfirm={() => resolve(true)} onCancel={() => resolve(false)}/>
 * );
 * ```
 */
export default function showModal(renderModal, rootEl = document.body) {
    return __awaiter(this, void 0, void 0, function* () {
        const mountEl = document.createElement("div");
        rootEl.appendChild(mountEl);
        try {
            const result = yield new Promise((resolve, reject) => {
                ReactDOM.render(renderModal(resolve, reject), mountEl);
            });
            return result;
        }
        finally {
            ReactDOM.unmountComponentAtNode(mountEl);
            rootEl.removeChild(mountEl);
        }
    });
}
